import {
    BsGithub,
    SiHashnode,
    BsTwitter,
    SiLinkedin,
    SiGmail
} from "../utils/icons";

export const footerLinks = [
    {
        link: "https://github.com/Namrata-J",
        linkIcon: <BsGithub />
    },
    {
        link: "https://namratajain.hashnode.dev/",
        linkIcon: <SiHashnode />
    },
    {
        link: "https://twitter.com/muse_the_coder",
        linkIcon: <BsTwitter />
    },
    {
        link: "https://www.linkedin.com/in/namrata-jain-2b6203216/",
        linkIcon: <SiLinkedin />
    },
    {
        link: "mailto: namratajain29001@gmail.com",
        linkIcon: <SiGmail />
    }
];